import { createReducerUsingActionHandlers, ERROR, PENDING, PURE, SUCCESS } from '@travel-frontend/state-handling-sdk';
import Cookies from 'js-cookie';
import { createSelector } from 'reselect';
import { firstLetterUpperCase } from '../../../components/Authentication/helpers.js';
import { authState } from '../../../components/Authentication/redux/AuthState.js';
import { ALIAS_TOKEN, CHECK_TOKEN, CREATE_PASSWORD, DO_LOGIN, DO_LOGOUT, DO_REGISTER, FORGOT_PASSWORD, GET_PROFILE_DATA, GET_STATUS, IS_SERVICE_AGENT, MIGRATE_ACCOUNT, NEW_PASSWORD, REFRESH_TOKEN, RESEND_VERIFICATION, RESET_ERRORS, SET_TOKEN, TOGGLE_COMPONENT, VERIFY_CUSTOMER } from '../../../components/Authentication/redux/models.js';
const initialState = {
  errorMessage: '',
  errorType: '',
  isLoading: false,
  currentComponent: '',
  isServiceAgent: !!Cookies.get(IS_SERVICE_AGENT),
  isStatusPending: !!Cookies.get(ALIAS_TOKEN),
  isLoggedIn: false,
  userInfo: {
    firstName: '',
    lastName: '',
    initials: '',
    customerID: ''
  },
  profileData: {
    emailAddress: '',
    gender: '',
    firstName: '',
    lastName: '',
    street: '',
    houseNumber: '',
    zipCode: '',
    city: '',
    countryCode: '',
    phoneNumber: '',
    birthday: ''
  }
};
const actionCreators = {
  [PENDING(DO_LOGIN)]: state => {
    return {
      ...state,
      isLoading: true
    };
  },
  [SUCCESS(DO_LOGIN)]: (state, action) => {
    return {
      ...state,
      aliasToken: action.data.aliasToken,
      expiresAt: action.data.expiresAt,
      isLoggedIn: true,
      isLoading: false,
      currentComponent: ''
    };
  },
  [ERROR(DO_LOGIN)]: (state, action) => ({
    ...state,
    errorMessage: action.error?.response.data.errorMessage,
    errorType: action.error?.response.data.errorType,
    isLoggedIn: false,
    isLoading: false
  }),
  [PENDING(VERIFY_CUSTOMER)]: state => ({
    ...state,
    isLoading: true
  }),
  [SUCCESS(VERIFY_CUSTOMER)]: state => ({
    ...state,
    currentComponent: 'verifyCustomerDialog',
    isLoading: false
  }),
  [ERROR(VERIFY_CUSTOMER)]: state => ({
    ...state,
    currentComponent: 'signInWidget',
    isLoading: false
  }),
  [ERROR(NEW_PASSWORD)]: state => ({
    ...state,
    isLoading: false
  }),
  [PENDING(NEW_PASSWORD)]: state => ({
    ...state,
    isLoading: true
  }),
  [SUCCESS(NEW_PASSWORD)]: state => ({
    ...state,
    currentComponent: 'createPasswordDialog',
    isLoading: false
  }),
  [PENDING(DO_REGISTER)]: state => ({
    ...state,
    isLoading: true
  }),
  [SUCCESS(DO_REGISTER)]: state => ({
    ...state,
    currentComponent: 'registrationDialog',
    isLoading: false
  }),
  [ERROR(DO_REGISTER)]: (state, action) => ({
    ...state,
    errorMessage: action.error.response.data.errorMessage,
    errorType: action.error.response.data.errorType,
    isLoading: false
  }),
  [PENDING(GET_PROFILE_DATA)]: state => ({
    ...state,
    isLoading: true
  }),
  [SUCCESS(GET_PROFILE_DATA)]: (state, action) => ({
    ...state,
    profileData: action.data,
    isLoading: false
  }),
  [ERROR(GET_PROFILE_DATA)]: (state, action) => ({
    ...state,
    errorMessage: action.error.response.data.errorMessage,
    errorType: action.error.response.data.errorType,
    isLoading: false
  }),
  [PENDING(GET_STATUS)]: state => ({
    ...state,
    isLoading: true,
    isStatusPending: true
  }),
  [SUCCESS(GET_STATUS)]: (state, action) => ({
    ...state,
    userInfo: action.data,
    isLoggedIn: action.data.isLoggedIn,
    isStatusPending: false,
    isLoading: false
  }),
  [ERROR(GET_STATUS)]: (state, action) => ({
    ...state,
    errorMessage: action.error.response.data.errorMessage,
    errorType: action.error.response.data.errorType,
    isLoggedIn: false,
    isStatusPending: false
  }),
  [PENDING(RESEND_VERIFICATION)]: state => ({
    ...state,
    isLoading: true
  }),
  [SUCCESS(RESEND_VERIFICATION)]: state => ({
    ...state,
    currentComponent: 'registrationDialog',
    isLoading: false
  }),
  [ERROR(RESEND_VERIFICATION)]: (state, action) => ({
    ...state,
    errorMessage: action.error?.response.data.errorMessage,
    errorType: action.error?.response.data.errorType,
    isLoading: false
  }),
  [PENDING(FORGOT_PASSWORD)]: state => ({
    ...state,
    isLoading: true
  }),
  [SUCCESS(FORGOT_PASSWORD)]: state => ({
    ...state,
    currentComponent: 'forgotPasswordDialog',
    isLoading: false
  }),
  [ERROR(FORGOT_PASSWORD)]: (state, action) => ({
    ...state,
    isLoading: false,
    errorMessage: action.error?.response.data.errorMessage,
    errorType: action.error?.response.data.errorType
  }),
  [PENDING(MIGRATE_ACCOUNT)]: state => ({
    ...state,
    isLoading: true
  }),
  [SUCCESS(MIGRATE_ACCOUNT)]: state => ({
    ...state,
    currentComponent: 'migrateAccountDialog',
    isLoading: false
  }),
  [ERROR(MIGRATE_ACCOUNT)]: state => ({
    ...state,
    currentComponent: 'migrateAccountDialog',
    isLoading: false
  }),
  [PENDING(CREATE_PASSWORD)]: state => ({
    ...state,
    isLoading: true
  }),
  [SUCCESS(CREATE_PASSWORD)]: state => ({
    ...state,
    isLoading: false,
    currentComponent: 'createPasswordDialog'
  }),
  [ERROR(CREATE_PASSWORD)]: state => ({
    ...state,
    isLoading: false
  }),
  [PENDING(CHECK_TOKEN)]: state => ({
    ...state,
    isLoading: true
  }),
  [SUCCESS(CHECK_TOKEN)]: state => ({
    ...state,
    isLoggedIn: true,
    isLoading: false
  }),
  [ERROR(CHECK_TOKEN)]: (state, action) => ({
    ...state,
    isLoggedIn: false,
    errorMessage: action.error?.response.data.errorMessage,
    errorType: action.error?.response.data.errorType,
    isLoading: false
  }),
  [PENDING(REFRESH_TOKEN)]: state => ({
    ...state,
    isLoading: true
  }),
  [SUCCESS(REFRESH_TOKEN)]: state => ({
    ...state,
    isLoggedIn: true,
    isLoading: false
  }),
  [ERROR(REFRESH_TOKEN)]: (state, action) => ({
    ...state,
    isLoggedIn: false,
    isLoading: false,
    errorMessage: action.error?.response.data.errorMessage,
    errorType: action.error?.response.data.errorType
  }),
  [PURE(DO_LOGOUT)]: state => ({
    ...state,
    isLoggedIn: false,
    isServiceAgent: false,
    userInfo: {
      firstName: '',
      lastName: '',
      initials: '',
      customerID: ''
    }
  }),
  [PURE(SET_TOKEN)]: state => ({
    ...state,
    isLoggedIn: true,
    isServiceAgent: true
  }),
  [PURE(RESET_ERRORS)]: state => ({
    ...state,
    errorType: '',
    errorMessage: ''
  }),
  [PURE(TOGGLE_COMPONENT)]: (state, action) => {
    const {
      componentType,
      component
    } = action;
    const selected = `${component}${firstLetterUpperCase(componentType)}`;
    return {
      ...state,
      currentComponent: state.currentComponent === selected ? '' : selected
    };
  }
};
export const isLoggedIn = createSelector(authState, state => state.isLoggedIn);
export const isServiceAgent = createSelector(authState, state => state.isServiceAgent);
export const status = createSelector(authState, state => state.userInfo);
export const profileData = createSelector(authState, state => state.profileData);
export const currentComponent = createSelector(authState, state => state.currentComponent);
export const isPending = createSelector(authState, state => state.isStatusPending);
export const authReducer = createReducerUsingActionHandlers(initialState, actionCreators);